// Staff Access OS — session API client. Uses same-origin cookies
// (credentials:'include') + CSRF token (X-CSRFToken from the csrftoken cookie,
// primed by GET /api/staff/csrf/). No token is ever stored in JS/localStorage.
import { API_BASE } from './env';

const BASE = API_BASE + '/api/staff';

function getCookie(name) {
  const m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return m ? decodeURIComponent(m.pop()) : '';
}

async function ensureCsrf() {
  if (!getCookie('csrftoken')) {
    await fetch(BASE + '/csrf/', { credentials: 'include' });
  }
  return getCookie('csrftoken');
}

export async function reqUrl(method, url, body) {
  const opts = { method, credentials: 'include', headers: {} };
  if (method !== 'GET') {
    opts.headers['Content-Type'] = 'application/json';
    opts.headers['X-CSRFToken'] = await ensureCsrf();
    if (body !== undefined) opts.body = JSON.stringify(body);
  }
  const r = await fetch(url, opts);
  let data = null;
  try { data = await r.json(); } catch (e) { /* no body */ }
  if (!r.ok) {
    const err = new Error((data && data.detail) || (data && data.error) || ('Ошибка ' + r.status));
    err.status = r.status;
    err.data = data;
    throw err;
  }
  return data;
}

function req(method, path, body) {
  return reqUrl(method, BASE + path, body);
}

export const staff = {
  me: () => req('GET', '/me/'),
  login: (username, password) => req('POST', '/login/', { username, password }),
  logout: () => req('POST', '/logout/'),
  stationAuthorize: (hall, label) => req('POST', '/station/authorize/', { hall, label }),
  stationClear: () => req('POST', '/station/clear/'),
  pinLogin: (pin) => req('POST', '/pin-login/', { pin }),
  pinLogout: () => req('POST', '/pin-logout/'),
  employees: () => req('GET', '/employees/'),
  createEmployee: (p) => req('POST', '/employees/', p),
  updateEmployee: (id, p) => req('PATCH', '/employees/' + id + '/', p),
  blockEmployee: (id) => req('DELETE', '/employees/' + id + '/'),
  resetCredential: (id, p) => req('POST', '/employees/' + id + '/reset/', p),
  deleteEmployee: (id) => req('POST', '/employees/' + id + '/delete/', {}),
  sessions: () => req('GET', '/sessions/'),
  endStation: (id) => req('POST', '/sessions/' + id + '/end/'),
  audit: () => req('GET', '/audit/'),
};

// Reception intake-by-bracelet (separate endpoint, same cookie+CSRF transport).
export const reception = {
  // OPS-1 reception desk
  checkin: (body) => reqUrl('POST', API_BASE + '/api/reception/checkin/', body),
  checkout: (braceletNumber, force) => reqUrl('POST', API_BASE + '/api/reception/checkout/', { bracelet_number: String(braceletNumber), ...(force ? { force: true } : {}) }),
  queueCancel: (braceletNumber, reason) => reqUrl('POST', API_BASE + '/api/reception/queue-cancel/', { bracelet_number: String(braceletNumber), reason }),
  visits: () => reqUrl('GET', API_BASE + '/api/reception/visits/'),
  endOfShift: (confirm) => reqUrl('POST', API_BASE + '/api/reception/end-of-shift/', confirm ? { confirm: 'ЗАКРЫТЬ СМЕНУ' } : {}),
  enqueueBracelet: (braceletNumber, { gender, serviceChoices, isExpress } = {}) =>
    reqUrl('POST', API_BASE + '/api/reception/bracelet-enqueue/', {
      bracelet_number: String(braceletNumber),
      ...(gender ? { gender } : {}),
      ...(serviceChoices ? { service_choices: serviceChoices } : {}),
      ...(isExpress ? { is_express: true } : {}),
    }),
};

export const HALLS = [
  { v: 'any', t: 'Любой' },
  { v: 'men', t: 'Мужской зал' },
  { v: 'women', t: 'Женский зал' },
  { v: 'massage', t: 'Массаж' },
];
export const ROLE_LABEL = { ADMIN: 'Администратор', RECEPTION: 'Ресепшн', MASTER: 'Мастер', BAR: 'Бар' };
export const HALL_LABEL = { any: 'Любой', men: 'Мужской', women: 'Женский', massage: 'Массаж' };
